<ion-label color="medium" class="ion-no-padding ion-no-margin ion-margin-horizontal">
    <h3 [innerHtml]="label | safe: 'html'"></h3>
</ion-label>
